import posthog from 'posthog-js';

import useFeature, { FeatureKeys } from '@/hooks/useFeature';

export const useIsPulseEnabled = (): boolean => {
  return useFeature(FeatureKeys.PULSE);
};

export const isPulseEnabled = (): boolean => {
  if (import.meta.env.REACT_APP_SARAL_ENV !== 'prod') return true;
  return !!posthog.isFeatureEnabled(FeatureKeys.PULSE);
};
